const ArrowIcon = ({ color = "#000000", height, rotate }) => {
  return (
    <svg
      fill={color}
      height={height}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
      transform={"rotate(" + rotate + ")"}
    >
      <path
        d="M1225.982 926.244c27.296 18.796 27.3 49.269 0 68.067l-509.836 351.074c-27.296 18.797-49.424 7.18-49.424-25.959V601.13c0-33.133 22.125-44.757 49.424-25.959l509.836 351.074Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ArrowIcon;
